/** Matches the server's rule: lowercase ASCII letters and digits, separated by single dashes. */
export const SLUG_PATTERN = '[a-z0-9]+(-[a-z0-9]+)*'
const MAX_SLUG_LENGTH = 64

/** Suggests a URL slug from an event name, e.g. "Championnat d'Anse 2027" → "championnat-d-anse-2027". */
export function slugify(name: string): string {
  return name
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .slice(0, MAX_SLUG_LENGTH)
    .replace(/^-+|-+$/g, '')
}
